import { atom } from "recoil";

export const langState = atom({
  key: "langState",
  default: "en-US",
});

export const cookieConsentState = atom({
  key: "cookieConsentState",
  default: false,
});

export const firstLoadState = atom({
  key: "firstLoadState",
  default: false,
});
